import Switch from "./Switch.mjs";
export * from "./Switch.mjs";
var lib_default = Switch;
export {
  lib_default as default
};
